import React from "react";

const INTENT_COPY = {
  wake: "Trouvé · listening for command…",
  next: "Trouvé · next step ✨",
  previous: "Trouvé · going back",
  done: "Trouvé · marked done",
  snap: "Trouvé · taking a snapshot",
  exit: "Trouvé · closing the mirror",
};

/**
 * Voice-command flash pill — confirms the wake word was heard or a
 * command fired. Auto-dismisses after 1.8s via a timer in the parent
 * useEffect that syncs `voice.lastIntent → voiceFlash`.
 */
const LiveCoachVoiceFlash = ({ flash }) => {
  if (!flash) return null;
  const intent = flash.intent;
  const copy = INTENT_COPY[intent] || `Trouvé · ${intent}`;
  return (
    <div
      key={flash.at}
      className="absolute top-[calc(max(env(safe-area-inset-top),20px)+92px)] right-5 z-30 bg-[#1a1416]/85 backdrop-blur-md border border-[#D5A8A4]/40 rounded-full px-3.5 py-1.5 flex items-center gap-2 animate-in fade-in slide-in-from-top-1 duration-200"
      data-testid="live-coach-voice-flash"
    >
      <span className="h-2 w-2 rounded-full bg-[#FFE6D7] animate-pulse" />
      <span className="text-[#FFE6D7] text-[11px] tracking-wide">{copy}</span>
    </div>
  );
};

export default LiveCoachVoiceFlash;
